export const PublicIdCode = {
  decode(code: string): number | null {
    const raw = code.toLowerCase().replaceAll("-", "").trim();

    if (!raw) return null;

    let result = 0;

    for (const char of raw) {
      if (char < "a" || char > "z") {
        return null;
      }

      const value = char.charCodeAt(0) - "a".charCodeAt(0);
      result = result * 26 + value;
    }

    if (!Number.isSafeInteger(result)) {
      return null;
    }

    return result;
  },

  isEncodedPublicId(value: string): boolean {
    const normalized = value.trim().toLowerCase();

    if (!normalized) return false;

    // Transfer IDs look like: doh-jch-o
    // Chat numbers look like: 4925-1104-5120
    return /^[a-z-]+$/.test(normalized) && /[a-z]/.test(normalized);
  },
};